import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";


interface Props {
  errorMessage: string;
  upload: () => Promise<void>;
  onCloseModal: () => void;
}

export const ConfirmDiscreteBalancesModal = ({ errorMessage, upload, onCloseModal }: Props) => {
  return (
    <BasePageModal
      handleClose={onCloseModal}
      title="残高不連続エラー"
      bottomChildren={
        <>
        <BaseRoundButton
          buttonText="はい"
          className="btn-ok"
          onClick={() => {
            upload();
          }}
        />
        <BaseRoundButton
          buttonText="キャンセル"
          className="btn-cancel"
          onClick={() => {
            onCloseModal();
          }}
        />
        </>
      }
    >
      <h2>
        {errorMessage.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </h2>
    </BasePageModal>
  );
};
